import React from "react";
import { BiSearch } from "react-icons/bi";

const SearchBar = ({ searchTerm, setSearchTerm, setSearchData }) => {
  return (
    <div className="relative w-full sm:max-w-md sm:min-w-[220px] flex-1 lg:flex-none">
      <input
        type="text"
        className="bef-input !pr-12"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setSearchData(searchTerm);
          }
        }}
      />
      <button
        type="button"
        aria-label="Search"
        className="absolute top-0 right-0 px-4 h-full min-w-[2.75rem] bg-primary text-white rounded-r-xl transition-all duration-300 hover:bg-accent hover:text-white"
        onClick={() => setSearchData(searchTerm)}
      >
        <BiSearch />
      </button>
    </div>
  );
};

export default SearchBar;
